import React, { useState, FC } from 'react'
import { Col, Button, Popconfirm } from 'antd'
import styles from './index.module.less'

interface AccountActionsProps {
	deleteAction(): Promise<void>
}

const AccountActions: FC<AccountActionsProps> = ({ deleteAction }) => {
	const [isDeleting, setIsDeleting] = useState<boolean>(false)
	const handleDelete = async (): Promise<void> => {
		setIsDeleting(true)
		await deleteAction()
		setIsDeleting(false)
	}

	return (
		<>
			<Col>
				<Popconfirm title='Are you sure you want to delete?' onConfirm={handleDelete}>
					<Button loading={isDeleting} type='danger' icon='delete' className={styles.customerButton}>
						{isDeleting ? 'Deleting' : 'Delete'}
					</Button>
				</Popconfirm>
			</Col>
		</>
	)
}

export default AccountActions
